<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{data?.title}}</h3>
			</div>
			<div class="zesty-modal__content">
				<form [formGroup]="form">
					<div class="permission-container">
						<div class="radio-label"> Permission Level</div>
						<mat-radio-group formControlName="permissionLevel">
							<mat-radio-button [value]="permissionLevel.readOnly"
																[tooltip]="readonlyTooltip" placement="bottom">{{ permissionLevel.readOnly }}
							</mat-radio-button>
							<mat-radio-button [value]="permissionLevel.management"
																[tooltip]="managedTooltip" placement="bottom">{{ permissionLevel.management }}
							</mat-radio-button>
							<mat-radio-button
								[tooltip]="payerTooltip" placement="bottom"
								[value]="permissionLevel.payerManagement">{{ permissionLevel.payerManagement }}
							</mat-radio-button>
							<mat-radio-button
								[tooltip]="customTooltip" placement="bottom"
								[value]="permissionLevel.custom">{{ permissionLevel.custom }}
							</mat-radio-button>
						</mat-radio-group>
					</div>

					<ng-template #accountsBlock>
						<div class="account-selects-container">
							<mat-form-field>
								<mat-label>Organization</mat-label>
								<mat-select formControlName="organization">
									<mat-option *ngFor="let org of organizations" [value]="org">{{org.org_name}}</mat-option>
								</mat-select>
							</mat-form-field>
						</div>

						<ng-container formArrayName="accounts">
							<p class="new-account__row-title">Accounts:</p>
							<div class="new-account__row new-account__row--composed"
									 *ngFor="let account of accounts.controls; let i = index">
								<ng-container [formGroupName]="i">
									<mat-form-field appearance="legacy">
										<mat-label>Name:</mat-label>
										<input matInput type="text" formControlName="name" autocomplete="off">
									</mat-form-field>
									<button class="new-account__remove"
													[disabled]="accounts.length < 2"
													(click)="removeAccount(i)"></button>
								</ng-container>
							</div>
							<div class="text-center">
								<button class="new-account__add"
												(click)="addAccount()"></button>
							</div>
						</ng-container>
					</ng-template>

					<ng-container *ngIf="permission.value !== permissionLevel.custom"
												[ngTemplateOutlet]="accountsBlock"></ng-container>

					<div *ngIf="permission.value === permissionLevel.custom"
							 class="custom-permissions">
						<mat-horizontal-stepper (selectionChange)="stepChanged($event)">
							<mat-step>
								<ng-template matStepLabel>Pick permissions</ng-template>
								<app-onboarding-permissions-tree [partnersMode]="true"
																								 (emitPermissions)="collectPermissions($event)"
																								 [submitSubject]="permissionsSubject$"></app-onboarding-permissions-tree>
								<div class="text-right">
									<button class="step-btn"
													[disabled]="isLoading$ | async"
													(click)="permissionsSubject$.next(true)"
													mat-button matStepperNext>Next
										<mat-icon class="mat-icon-rtl-mirror">chevron_right</mat-icon>
									</button>
								</div>
							</mat-step>
							<mat-step>
								<ng-template matStepLabel>Manage links</ng-template>
								<ng-container [ngTemplateOutlet]="accountsBlock"></ng-container>
								<div class="text-left">
									<button class="step-btn"
													[disabled]="isLoading$ | async"
													mat-button matStepperPrevious>
										<mat-icon class="mat-icon-rtl-mirror">chevron_left</mat-icon>
										Back
									</button>
								</div>
							</mat-step>
						</mat-horizontal-stepper>
					</div>
				</form>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button class="zesty-modal__create-btn"
								(click)="generateLinks()"
								[disabled]="form.invalid ||
								(permission.value === permissionLevel.custom && selectedStep !== 1)">
					Generate
				</button>
			</div>
		</div>
	</div>
</div>

<ng-template #readonlyTooltip>
	<div class="p-1 text-left">
		EC2 (Read-Only) <br>
		Databases (Read-Only) <br>
		S3 (Read-Only) <br>
	</div>
</ng-template>
<ng-template #managedTooltip>
	<div class="p-1 text-left">
		EC2 (Read-Only) <br>
		Databases (Read-Only) <br>
		S3 (Read-Only) <br>
		EC2 Reserved Instances <br>
		Zesty Disk
	</div>
</ng-template>
<ng-template #payerTooltip>
	<div class="p-1 text-left">
		EC2 (Read-Only) <br>
		Databases (Read-Only) <br>
		S3 (Read-Only) <br>
		Saving Plans Routing
	</div>
</ng-template>
<ng-template #customTooltip>
	<div class="p-1 text-left">
		Select permission manually
	</div>
</ng-template>
